export const findAccountdeletedrequest = async (mobile, country_code) => {
  try {
    const headers = new Headers();

    headers.append("Accept", "application/json");

    const callotpverify = await fetch(
      `${
        process.env.REACT_APP_BASE_URL
      }/api/findAccountIfDeleted?mobile=${mobile}&country_code=${
        "+" + country_code
      }`,
      {
        headers,
        method: "GET",
      }
    );

    return callotpverify;
  } catch (error) {}
};
